const baseUrl = 'https://api.fatsme.online/api';
// const baseUrl = 'http://localhost:7001/api';
export const imagebaseUrl = 'https://api.fatsme.online';
// export const imagebaseUrl = 'http://localhost:7001';
// const baseUrl = 'http://161.97.172.46:7001/api'
export const gtrackUrl = 'https://gtrack.online/api'
// const baseUrl = 'http://localhost:7001/api'
export const baseUrlgs1 = 'https://api.fatsme.online/api';
export default baseUrl;


